import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { qaTestingConfig } from './servicePageConfigs';

const QATesting = () => <ServicePageTemplate {...qaTestingConfig} />;

export default QATesting;
